import { get } from 'wtb-utils';

const termsApi = `${import.meta.env.VITE_CDN_URL}/wtb/terms`;
const merchantApi = (merchantId) => `${import.meta.env.VITE_CDN_URL}/merchant/${merchantId}/terms`;

const getTerms = () => get(termsApi);

const getMerchantTerms = (merchantId) => get(merchantApi(merchantId));

export {
  getTerms,
  getMerchantTerms
};
